import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { promotionEndpoint } from '../services/nopAPI';

export const usePromotionStore = defineStore('promotion', () => {
  const promotions = ref([]);
  const promotionCount = computed(() => promotions.value.length);

  async function initializePromotion() {
    try {
      const resp = await promotionEndpoint.getPromotions();
      promotions.value = resp.Promotions;
    } catch (error) {
      console.error('error initializePromotion', error);
    }
  }
  return {
    initializePromotion,
    promotions,
    promotionCount,
  };
});
